module.exports = {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  client_id: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
};
